module.exports = __webpack_public_path__ + "media/images/partner-10-a936b0c622ef32372c0a97a8d0fe9d92.png";